/**
 * useAbility Hook
 *
 * Access the current CASL ability from context.
 *
 * @layer features
 * @slice authorization
 * @segment model
 * @added DOC-0064 (2025-12-19)
 * @updated DOC-0095 (2025-12-26) - Migrated to FSD features/authorization
 */

import { useContext } from 'react';
import { AbilityContext } from './ability-context';
import type { AppAbility } from '@shared/types/ability';

/**
 * Hook to access current ability
 */
export function useAbility(): AppAbility {
  return useContext(AbilityContext);
}
